import React from "react";
import BarSvg from "./bar-svg";
import Box from  '@material-ui/core/Box'


const ProgressDiagram = props => {
  const { data, isBarChart } = props;

  const bar = (
    <BarSvg
        key={data.id}
        stops={data.stops}
        width={data.duration}
        x={0}
        y={0}
        isBarChart={isBarChart}
        inversed={data.from === 'bot'? true: false}
      />
  );

  if (isBarChart) {
      return (
          <Box height={150} display="flex" alignSelf={data.from === 'bot'? 'flex-end': 'flex-start'}>
              <Box p={0} ml={data.interval}  display="flex" justifyContent="flex-start" alignItems={data.from === 'bot'? 'flex-start': 'flex-end'}>
                  {bar}
              </Box>
          </Box>
      );
  }

  return (
      <Box p={0} ml={data.interval} display="flex" alignItems="center" alignSelf={data.from === 'bot'? 'flex-end': 'flex-start'}>
          {bar}
      </Box>
  );
};

export default ProgressDiagram;
